var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackCloudLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4033 0.40625C24.1511 0.406502 28 4.22072 28 8.92578C28 13.6309 24.1511 17.4451 19.4033 17.4453C17.356 17.4453 15.4765 16.7348 14 15.5508C12.5235 16.7348 10.644 17.4453 8.59668 17.4453C3.84883 17.4451 0 13.6309 0 8.92578C2.96442e-05 4.22068 3.84885 0.406424 8.59668 0.40625C10.6438 0.40625 12.5236 1.116 14 2.2998C15.4764 1.11604 17.3563 0.40625 19.4033 0.40625Z",
    fill: "url(#paint0_radial_5608_23501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5608_23501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19 9.40625) rotate(90) scale(14 23.0057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCloudLogo);
export default __webpack_public_path__ + "static/media/blackCloudLogo.ab3c7d305d43a9f2f0a17e470391f7ab.svg";
export { ForwardRef as ReactComponent };